export default "__VITE_ASSET__FgAY5UVi__"